import { gql } from '@apollo/client';

export default gql`
  query adjustmentReasons {
    loyaltyPointsAdjustmentReasons {
      code
      description
    }
  }
`;
